import { render, staticRenderFns } from "./MainField.vue?vue&type=template&id=236faedb"
import script from "./MainField.vue?vue&type=script&lang=js"
export * from "./MainField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports